import {React, computed, _} from '@api'
import {ICatalogItemDetailsPathElement, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'

export class VLPProductCardStore extends VipLocalStore {
  constructor(stores: StoresInstance, public data: any) {
    super(stores)
  }

  @computed get id() {
    const {data, catalog: {idFor}} = this
    return idFor(data)
  }

  @computed get images() {
    const {data} = this,
      {catalog: {selectedImageSourceFields}, stores: {es}} = this

    const r = _.flatMap(selectedImageSourceFields, f => es.readField(data, f ?? 'images').val).filter(_.identity)
    return r
  }

  @computed get isHex(): boolean {
    return _.startsWith(this.imageUrl, '#')
  }

  @computed get isImage(): boolean {
    return !_.isEmpty(this.imageUrl) && !this.isHex
  }

  @computed get imageWithBackground() {
    const {catalog: {cssCardImage}} = this

    return cssCardImage['--catalog-image-background'] && cssCardImage['--card-image-align-self']
  }

  @computed get alignSelf() {
    const {catalog: {cssCardImage, selectedImageSourceFields, imageSourceOptions}} = this,
      imageSourceOption = imageSourceOptions.find(img => selectedImageSourceFields.includes(img.field))
    return imageSourceOption.workspace?.catalog?.features?.card?.alignSelf ?? cssCardImage['--card-image-align-self']
  }

  @computed get backgroundImage() {
    const {catalog: {imageBackgroundUrl}} = this

    return imageBackgroundUrl
  }

  @computed get imageRaw() {
    const {data, stores, catalog} = this, {} = stores,
      {imagesForCatalogItem} = catalog

    return _.first(imagesForCatalogItem({data}))
  }

  @computed get imageUrl() {
    const {catalog: {imageUrlFor}, imageRaw} = this
    return imageUrlFor(imageRaw, {c8Size: 'smallImage'}) ?? ''
  }

  @computed get path(): ICatalogItemDetailsPathElement[] {
    const {catalog, imageRaw, data} = this
    return catalog.pathForData(imageRaw, data, catalog.workspace.config)
  }

  @computed get itemUrl() {
    const {data, path, catalog, stores: {nav: {urlForObject}}} = this

    return urlForObject(data, path, catalog)
  }

}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VLPProductCardStore.tsx